module.exports = (s) => {
  return [
    {
      name: '渠道号',
      value: 'channel_alias',
    },
    {
      name: '单元名称',
      format: (row) => {
        const h = s.$createElement;
        const ele = h(
          'el-input',
          {
            props: {
              value: row.unit_name,
            },
            attrs: {
              placeholder: '请输入单元名称',
              showWordLimit: true,
              maxlength: 30,
            },
            on: {
              input: (value) => {
                row.unit_name = value;
              },
            },
          },
          null,
        );
        return ele;
      },
    },
  ];
};
